import React, { useContext, useEffect, useState } from "react";
import { LockerSvg } from "../svg/Locker";
import Featured from '../components/Featured';
import BarChart from '../components/BarChart';
import { Lessons } from '../components/Lessons'
import { DataContext } from "../context/DataContext";
import { AuthContext } from "../context/AuthContext";
import axios from 'axios';
import ReactPlayer from 'react-player/lazy';
import { toTitleCase } from '../util/titleCase';
import { useHistory } from 'react-router-dom';
import { animated, useSpring } from "react-spring";
import EmptyBoxSvg from '../svg/EmptyBoxSvg';
import ReactGA from 'react-ga';
import loadingSpin from '../images/loadingSpin.gif';
// import LoadingModal from '../components/common/LoadingModal'
import NtwrkErrMsg from "../components/common/NtwrkErrMsg";

// import { theme } from '../util/themeColor'

const Locker = () => {
    const dataContext = useContext(DataContext);
    const authContext = useContext(AuthContext);
    const history = useHistory()

    const id = JSON.parse(localStorage.getItem('studentInfo'));
    let deploymentIdx;
    let schoolDomain = window.location.host;
    if (schoolDomain.includes('localhost')) {
        // schoolDomain = "s-teeschool.edves.net"
        // schoolDomain = 'sgs.edves.net'
        schoolDomain = 'demo.edves.net'
        // deploymentIdx = JSON.parse(localStorage.getItem('subSchoolData')).idx;
        deploymentIdx = JSON.parse(localStorage.getItem('studentInfo'))[0].schoolidx;
    }
    // const schoolDomain = 'demo.edves.net';
    const studentId = id[0].studentId;
    const admissionnumber = JSON.parse(localStorage.getItem('studentInfo'))[0].admissionnumber;
    deploymentIdx = JSON.parse(localStorage.getItem('subSchoolData')).idx;

    // const schoolDomain = localStorage.getItem('schoolDomain');
    const firstname = JSON.parse(localStorage.getItem('studentInfo'))[0].parentorguardian;
    const schoolName = JSON.parse(localStorage.getItem('subSchoolData')).name;
    // const deploymentIdx = JSON.parse(localStorage.getItem('subSchoolData')).idx;
    // const studentId = authContext.studentInfo[0].studentId  ;
    
    const [videoUrl, setCurrVideo] = useState(dataContext.initialVideo);
    const [scoreChart, setScoreChart] = useState([]);
    const [lessonNote, setLessonNote] = useState([]);
    const [videos, setVideos] = useState([]);
    const [cbtScore, setCbtScore] = useState({});
    const [hwrkNoScore, setHwrkNoScore] = useState('')
    const [scoreChatMsg, setScoreChatMsg] = useState('');
    // const [ loadingNotes, setLoadingNotes ] = useState(true);
    const [netwrkErr, setNetwrkErr] = useState(false);
    const [cbtScoreStatus, setCbtScoreStatus] = useState(false);
    const [lessonNoteStatus, setLessonNoteStatus] = useState(false);
    const [lockerSummaryLoading, setLockerSummaryLoading] = useState(true);
    const [scoreChartStatus, setScoreChartStatus] = useState(false);
    
    useEffect(() => {
        const updatedUrl = dataContext.clickedVideoUrl;
        setCurrVideo(updatedUrl);
        //console.log(updatedUrl);

    }, [dataContext.clickedVideoUrl])
    
    useEffect(() => {
        let today = new Date();
        today.setDate(today.getDate() - 7);
        const formatWkDate = today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate();
        // let newNotes;
        const getStudentVideos = async () => {
            try {
                const { data } = await axios.get(`student/getallvideoNew/${schoolDomain}/${studentId}/${deploymentIdx}`);
                //console.log(data);
                setVideos(data.data)
                authContext.setStudentVideos(data.data);
            } catch (error) {
                //console.log(error)
            }
        };
        getStudentVideos();

        // <<<<<< Get New Notes Data >>>>>>
        const getWeekNotes = async () => {
            let newNotes;
            try {
                const { data } = await axios.get(`student/lessonNotes/${schoolDomain}/${studentId}/${deploymentIdx}`);
                // console.log(data.data);
                if(data.status) {
                    // setLockerSummaryLoading(false);
                    setLessonNoteStatus(true);
                    if(data.data.length > 0) {
                        newNotes = data.data[0].Available_Notes.filter(note => new Date(note.dater) >= new Date(formatWkDate.toString()))
                        setLessonNote(newNotes);
                    } else {
                        setLessonNote(data.data);
                    }
                } else {
                    setLessonNoteStatus(false);
                    setLessonNote(data.Message);
                }
                // console.log(data.data[0].Available_Notes)
            } catch (error) {
                // console.log(error)
            }
        };
        getWeekNotes();

        const queryData = {
            admissionnumber,
            SchoolUrl : schoolDomain,
            deploymentid : deploymentIdx
        }

        const getLockerSummary = async () => {
            try {
                const { data } = await axios.post(`${authContext.baseUrl}/student/lockerSumary`, queryData);

                {/* <<<<<< Get Last Homework Data >>>>>> */}
                if(!data.data.cbtScore.status) {
                    // setCbtScoreStatus(false)
                    setLockerSummaryLoading(false);
                    setHwrkNoScore(data.data.cbtScore.Message);
                    // console.log(data.data.cbtScore.Message);
                    // console.log(cbtScore)
                } else {
                    setLockerSummaryLoading(false);
                    setCbtScore(data.data.cbtScore.Message);
                    setCbtScoreStatus(true);
                };

                {/* <<<<<< Get Graph Data >>>>>> */}
                if (!data.data.scorechart.status) {
                    setScoreChatMsg(data.data.scorechart.Message)
                } else {
                    setScoreChartStatus(true);
                    setScoreChart(data.data.scorechart.Message);
                };

                {/* <<<<<< Get New Notes Data >>>>>> */}
                if(!data.data.LessonNote.status) {
                    setLockerSummaryLoading(false)
                    setLessonNoteStatus(false);
                    setLessonNote(data.data.LessonNote.Message);
                } else {
                    setLockerSummaryLoading(false)
                    // setLoadingNotes(false);
                    //setLessonNoteStatus(true);
                    //newNotes = data.data.LessonNote.Message.filter( note => new Date(note.dater) >= new Date(formatWkDate.toString()))
                    // console.log(data.data.LessonNote.Message);
                    //setLessonNote(newNotes);

                    // setLessonNote(data.data.LessonNote.Message);
                }

            } catch (error) {
                // setLoadingNotes(false);
                setNetwrkErr(true);
                setLockerSummaryLoading(false)
                // console.log('Locker Summary Error' , error)
            }
        };
        getLockerSummary()
        return () => {}
    }, []);
    // }, [dataContext.initialVideo, videos, admissionnumber,  cbtScore, deploymentIdx, studentId]);

    // useEffect(() => {
    //     loadingNotes && setShowModal(false);
    // }, [lessonNote])

    const Heading = () => (
        <div className='flex flex-col justify-between py-4'>
            <div className="text-sm sm:text-base lg:text-xl leading-7 text-white mt-1 "> Welcome back <br />
                <span className='font-semibold'> {toTitleCase(firstname)} </span>
            </div>
            <div className='flex text-white text-sm sm:text-base leading-5 font-semibold'>
                {schoolName && toTitleCase(schoolName)}
            </div>
        </div>
    );
    const PageSvg = () => (
        <>
            <LockerSvg />
        </>
    );

    const navTransition = useSpring({
        from: { transform: 'translateY(-100px)' },
        to: { transform: 'translateY(0px)' },
  })

    const Nav = () => {
        return (
        <animated.div style={navTransition} className='bg-blue-100 flex border-0 justify-between rounded-lg mt-4 sm:mt-7 px-6 py-4 shadow-lg'>
            <Heading />
            <PageSvg />
        </animated.div>
        )
    };

    const styles = useSpring({
        to: [
          { opacity: 1, transform: 'translateX(0)' },
        ],
        from: { opacity: 0, transform: 'translateX(80px)' },
        config: { duration: 750 },
    });


    return (
        <> 
            <div className="px-4 sm:flex sm:px-0">
                <div onClick={() => dataContext.setSideBarHidden(true)} className="w-full sm:w-2/3 sm:mx-0">
                    <Nav />
                    <animated.div style={styles} className="w-full flex flex-col lg:flex-row">

                        {/*  <<<<<< New Notes Section >>>>>> */}
                        <div className="pt-6 pl-8 sm:pl-0 sm:ml-6 w-full sm:w-1/3 mt-3 sm:block md:flex md:justify-center flex justify-center">
                            <div className="inset-0 z-1 rounded-l-md rounded-r-none border border-purple-200 mt-2 -ml-8 bg-purple-800 relative lockerSizing">
                                <div className="bg-white lockerSizing p-4 text-gray-100 -mt-3 -ml-3 inset-0 absolute  newNotesShadow">
                                    <div className="block newHomeworkPositioning">
                                        {!lockerSummaryLoading && lessonNoteStatus && lessonNote.length === 0 && !netwrkErr &&
                                            <div className="p-4 flex flex-col items-center w-56">
                                                <span className="font-bold flex justify-center pb-4"> No New Notes </span>
                                                <span className="flex justify-center pb-4 -ml-2">
                                                    <EmptyBoxSvg />
                                                </span>
                                                <span className="text-gray-300 text-center text-xs leading-tight flex justify-center pl-2"> Notes uploaded by teachers would be displayed here </span>
                                            </div>
                                        }
                                        {!lessonNoteStatus && !lockerSummaryLoading && !netwrkErr &&
                                            <NtwrkErrMsg errMsg = {lessonNote?.Message} showReload = { false } /> 
                                        }
                                        {/* { loadingNotes && !netwrkErr ?  */}
                                        { lockerSummaryLoading &&
                                            <div>
                                                <div className="flex justify-start mx-auto font-semibold text-gray-100 text-base mb-4">
                                                    You have uhm...
                                                </div>
                                                <img src={loadingSpin} className='mx-auto mt-16' alt='loading...' />
                                            </div>
                                        }
                                        { lessonNoteStatus && lessonNote.length !== 0 && !netwrkErr && !lockerSummaryLoading &&
                                            <>
                                                <div className="flex justify-start mx-auto font-semibold text-gray-100 text-base mb-4">
                                                    You have {lessonNote.length > 0 ? `${lessonNote.length} new notes` : lessonNote.length === 1 ? `1 new note` : '' } 
                                                </div>
                                                <div className="flex flex-col justify-center py-4 px-2 bg-blue-900 rounded mb-3">
                                                    <ReactGA.OutboundLink eventLabel="New note" to = {lessonNote.length > 0 && lessonNote[0].downloadURL} target = '_blank' className='cursor-pointer'> 
                                                        <span className="text-blue-100 text-sm leading-5">
                                                            {lessonNote.length > 0 && toTitleCase(lessonNote[0].subjectname)} 
                                                        </span> <br/>
                                                        <span className="text-gray-300 text-xs leading-4"> {lessonNote.length > 0 && toTitleCase(lessonNote[0].topic)} </span>
                                                    </ReactGA.OutboundLink>
                                                </div>
                                                <div className="flex w-full">
                                                    <div className="bg-yellow-900 w-full p-1 rounded">
                                                        {lessonNote.length > 1 ? 
                                                        <ReactGA.OutboundLink eventLabel="New note" to = {lessonNote[1].downloadURL} target = '_blank' className='cursor-pointer'> 
                                                            <span className="text-yellow-100 text-sm font-semibold leading-5"> {toTitleCase(lessonNote[1].subjectname)} </span> <br />
                                                            <span className="text-xs leading-4 font-medium text-gray-300"> {toTitleCase(lessonNote[1].topic)} </span>
                                                        </ReactGA.OutboundLink> : ''
                                                        }
                                                    </div>
                                                    {/* <div className="w-1/3 m-auto">
                                                        <div className="flex justify-center bg-green-900 rounded items-center pt-6 pb-6">
                                                            <span className="lockerDot border border-green-200 bg-green-200 rounded-full dotMargin"></span>
                                                            <span className="lockerDot border border-green-200 bg-green-200 rounded-full dotMargin"></span> 
                                                            <span className="lockerDot border border-green-200 bg-green-200 rounded-full"></span>
                                                        </div>
                                                    </div> */}
                                                </div>
                                                
                                                <div onClick={() => history.push('notes')} className="flex justify-center items-center w-32 mx-auto mt-6 cursor-pointer p-2 mb-2 text-gray-100 text-xs font-medium rounded border border-gray-500">
                                                    <span className="mr-2"> View All </span>
                                                    <svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M1.38232 1L4.38232 4L1.38232 7" stroke="#000114" stroke-width="1.5" stroke-linecap="round"/>
                                                    </svg>
                                                </div>
                                            </>
                                        }
                                        { netwrkErr && 
                                            <div className='mt-4'>
                                                <div className='text-center mx-auto font-semibold text-gray-100 text-base mb-4'> New Notes </div>
                                                <NtwrkErrMsg errMsg = 'Oops! Something Went Wrong' showReload = { true } /> 
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                         {/* <<<<<< Last Homework Section >>>>>> */}
                        <div className="bg-white w-full sm:w-2/3 p-4 sm:ml-6 mt-8 rounded-md newNotesShadow sm:block mx-auto">
                            {!lockerSummaryLoading && cbtScoreStatus && cbtScore && Object.keys(cbtScore).length === 0 && !netwrkErr &&
                                <div className="p-4 flex flex-col items-center w-56">
                                    <span className="font-bold flex justify-center pb-4"> No scores yet </span>
                                    <span className="flex justify-center pb-4 -ml-2">
                                        <EmptyBoxSvg />
                                    </span>
                                    <span className="text-gray-300 text-center text-xs leading-tight flex justify-center pl-2"> Your child's last CBT score would be displayed here </span>
                                </div> 
                            }
                            {!lockerSummaryLoading && !cbtScoreStatus && !netwrkErr &&
                                <div className='flex flex-col mt-4 justify-center items-center'>
                                    <div className='text-center mx-auto font-semibold text-gray-100 text-base mb-4'> CBT score </div>
                                    <NtwrkErrMsg errMsg = {hwrkNoScore} showReload = { false } /> 
                                </div>
                            }
                            {/* {loadingNotes ?  */}
                            { lockerSummaryLoading && 
                                <div className='w-full m-auto'>
                                    <div className="flex justify-start mx-auto font-semibold text-gray-100 text-base mb-4">
                                        Your child's last CBT score
                                    </div>
                                    <div className='block'>
                                        <img src={loadingSpin} className='mx-auto mt-16' alt='loading...' />
                                    </div>
                                </div>
                            }
                            { !lockerSummaryLoading && cbtScoreStatus && Object.keys(cbtScore).length !== 0 && !netwrkErr &&
                                <div className='w-full m-auto'>
                                    <div className="flex justify-start mx-auto font-semibold text-gray-100 text-base mb-4">
                                        Your child's last CBT score
                                    </div>
                                    <div className="w-full flex justify-between items-center mt-12">
                                        <span className="text-4xl text-blue-100 font-semibold leading-10">
                                            { cbtScore.score}/{cbtScore.totalquestion}
                                        </span>
                                        {/* <span className="flex justify-center items-center font-medium w-12 h-6 lockerScoreRadius text-green-100 text-xs bg-green-900 leading-3">
                                            Good
                                        </span> */}
                                    </div>
                                    <div className="bg-blue-900 font-medium text-xs text-gray-200 px-2 py-3 mt-5 rounded leading-4 uppercase">
                                        {cbtScore.subject}, {cbtScore.term}, {cbtScore.class}, {cbtScore.year}
                                    </div>
                                    {/* <div className="flex justify-center items-center mt-6 w-32 cursor-pointer p-2 text-gray-100 text-xs font-medium rounded border border-gray-500">
                                        <Link to='homework' className="mr-2"> View All </Link>
                                        <svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1.38232 1L4.38232 4L1.38232 7" stroke="#000114" stroke-width="1.5" stroke-linecap="round"/>
                                        </svg>
                                    </div> */}
                                </div>
                            }
                            { netwrkErr && 
                                <div className='flex flex-col mt-4 justify-center items-center'>
                                    <div className='text-center mx-auto font-semibold text-gray-100 text-base mb-4'> CBT score </div>
                                    <NtwrkErrMsg errMsg = 'Oops! Something Went Wrong' showReload = { true } /> 
                                </div>
                            }                        
                        </div>
                    </animated.div>

                    {/* <<<<<< Graph Section >>>>>> */}
                    {/* <<<<<< Temporarily hidden because it shows live scores even when result is not published >>>>>> */}
                    {/*
                        <div className="w-full bg-white mt-8 rounded-md px-4 py-4 newNotesShadow">
                            <h3 className='text-gray-100 text-sm sm:text-base font-semibold'> Subject Performance </h3>
                            {scoreChatMsg && <h3 className='font-semibold text-red-200'> {toTitleCase(scoreChatMsg)} </h3>}
                            <BarChart data = {scoreChart} />
                        </div>
                     */}

                    {/*  <<<<<< Video Player Section >>>>>> */}
                    <div className="hidden sm:block mt-8 rounded-md mb-4">
                        <span className="text-base text-gray-100 font-semibold my-8"> Recent Lessons </span>
                        <div className="w-full flex mt-3">
                            <div className="w-full h-full sm:w-1/2">
                                {videoUrl ?
                                <ReactPlayer
                                    url={videoUrl} 
                                    width="100%"
                                    height="100%"
                                    playsinline = 'true'
                                    controls = 'true'
                                    pip = 'true'
                                    // playIcon
                                    volume
                                /> 
                                :
                                <ReactPlayer 
                                    url={videos && videos.length > 0 && videos[0].longurl} 
                                    width="100%"
                                    height="100%"
                                    playsinline = 'true'
                                    controls = 'true'
                                    pip = 'true'
                                    // playIcon
                                    volume
                                /> }
                            </div>
                            <div className=" w-1/3 ml-6">
                                <Lessons />
                            </div>
                        </div>
                    </div>
                </div>

                {/* <<<<<< Our Ad. Section >>>>>> */}
                <div className="w-full sm:w-1/3 sm:mx-4 mt-2">
                    <Featured />
                </div>
            </div>
        </>
    )
}

export default Locker;